import { ObjectValues } from '@app/types';
import { Cart, CouponType } from './cart';

export const UpdateLineItemErrorCodes = {
  QuantityInvalid: 'invalid_item_quantity',
  InvalidInput: 'invalid_cart_item_input',
  ItemNotFound: 'cart_item_not_found',
  UnexpectedError: 'cart_item_unexpected_error',
} as const;

export type UpdateLineItemErrorCodeType = ObjectValues<
  typeof UpdateLineItemErrorCodes
>;

export type UpdateLineItemAPIError = {
  error: {
    error_code: UpdateLineItemErrorCodeType;
    error_params?: Record<string, string>;
  };
};

export type UpdateLineItemAPISuccess = {
  cart: Cart;
};

export type UpdateLineItemAPIResponse =
  | UpdateLineItemAPIError
  | UpdateLineItemAPISuccess;

export type ApplyCouponAPISuccess = {
  type?: string;
  code?: string;
  sub_discount?: number;
  full_discount?: number;
  amount?: number;
  amount_in_buyer_currency?: number;
  currency?: string;
  display_name?: string;
  expiry_date?: string;
  is_expired?: boolean;
  cart: Cart;
};

export type ApplyCouponAPIError = {
  error: string;
  error_params?: Record<string, string>;
  error_code?: string;
};

export type ApplyCouponAPIResponse =
  | ApplyCouponAPISuccess
  | ApplyCouponAPIError;

export type RemoveCouponAPISuccess = { cart: Cart };

export type RemoveCouponAPIError = {
  error_code: string;
  error_params: Record<string, string>;
};

export type RemoveCouponAPIResponse =
  | RemoveCouponAPISuccess
  | RemoveCouponAPIError;

export type AddLineItemAPISuccess = {
  cart: Cart;
};

export const AddCartLineItemErrorCodes = {
  InvalidCartItemInput: 'invalid_cart_item_input',
  InvalidInventoryItemId: 'invalid_inventory_item_id',
  InventoryItemNotAvailable: 'inventory_item_not_available',
  InvalidItemQuantity: 'invalid_item_quantity',
  CartExceedsMaximumItems: 'cart_exceed_maximum_items',
  CartItemCreateUnexpectedError: 'cart_item_create_unexpected_error',
} as const;

export type AddCartLineItemErrorCodeType = ObjectValues<
  typeof AddCartLineItemErrorCodes
>;

export type AddLineItemAPIError = {
  error_code: AddCartLineItemErrorCodeType;
  error_params?: Record<string, string>;
};

export type AddLineItemAPIErrors = {
  errors: AddLineItemAPIError[];
};

export type AddLineItemAPIResponse =
  | AddLineItemAPISuccess
  | AddLineItemAPIErrors;

export type AddLineItemAPIRequest = {
  inventory_item_id: string;
  quantity: number;
};

export type AssignedCoupon = {
  type: CouponType;
  code: string;
  amount: number;
  currency: string;
  display_name: string;
  expiry_date: string;
};

// XXX(ai): These query params are what the Monolith cart controller can use to calculate more accurate cart prices.
// Note that the param names are re-mapped in all NextJS pages that forward them to the Monolith.
export type CartQueryShippingAddress = {
  countryCode?: string | null;
  postcode?: string | null;
  state?: string | null;
  city?: string | null;
  addressLine2?: string | null;
  addressLine1?: string | null;
};

export type UpdateShippingDetailsAPIRequest = CartQueryShippingAddress & {
  countryCode: string;
};
